// toggleSubscribeOnlineStatus.js
'use strict';
import { updatePusherChannelTarget } from '../resource/pusherUtils.js';
import Delay from '../resource/Delay.js';
import { RealtimeFeatureName } from '../resource/realtimeConstants.js';

import {
  subscribeFeatures,
  unsubscribeFeatures,
} from '../action/realtimeActions.js';

const pendings = new Set();

/**
 * Toggle subscribe online status
 * @kind action
 * @param {string} {userId} - user id.
 * @param {bool} {shouldSubscribe} - should subscribe or unsubscribe
 * @param {bool} {shouldRetry} - should retry to subscribe channel.
 * @param {string} {subscriptionReference} - subscription reference for identify subscribe reason and source
 * @return {Promise} Action promise.
 */
const toggleSubscribeOnlineStatus =
  ({ userId, shouldSubscribe, shouldRetry, subscriptionReference }) =>
  async dispatch => {
    updatePusherChannelTarget({
      target: {
        [`private-enc-user@${userId}`]: {
          shouldSubscribe,
          subscriptionReference,
          isCritical: shouldRetry,
        },
      },
    });

    if (shouldSubscribe) {
      pendings.add(userId);

      // batch features to subscribe at once, and use `Set` to avoid duplicate items.
      await new Delay(500).promise();

      const features = [...pendings].map(id => ({
        feature: RealtimeFeatureName.LIVESTREAM_PREVIEW,
        objectId: id,
      }));

      pendings.clear();

      if (features.length > 0) {
        dispatch(
          subscribeFeatures({
            features,
          })
        );
      }
    } else {
      dispatch(
        unsubscribeFeatures({
          features: [
            {
              feature: RealtimeFeatureName.LIVESTREAM_PREVIEW,
              objectId: userId,
            },
          ],
        })
      );
    }

    return dispatch({ type: '' });
  };

export default toggleSubscribeOnlineStatus;
